// Supplier rating — the five-star display of a market product's supplier
// (owner approval 2026-10-19: show the real rating as stars, numerically too).
//
// Source: market_products.seller_rating, written by hiobuy-gateway from the
// supplier's own record (1688 sellerDataInfo.compositeServiceScore; the raw
// record is kept verbatim in market_products_internal.upstream_extract). The
// 0–5 scale is inferred from the data, not documented by the provider — the
// stored row says so in scale_basis.
//
// Rules this file enforces, so no page has to remember them:
//   • a missing, zero, non-numeric or out-of-range score → null → nothing shown;
//   • no review count — the source has none, and none is invented;
//   • nothing here is a MAABAR verification; the page labels it as the
//     supplier's own record and never calls the supplier verified (owner
//     decision 2026-10-20: no negative "not verified" label either).

/** { value, text, fills[5] } for a valid 0–5 score, else null. */
export function supplierStars(rating) {
  const v = Number(rating?.service_score);
  if (rating?.service_score == null || rating?.service_score === '' || !Number.isFinite(v) || v <= 0 || v > 5) return null;
  return {
    value: v,
    text: v.toFixed(1),
    // Each star's filled share, 0..1 — 4.3 → [1, 1, 1, 1, 0.3].
    fills: [0, 1, 2, 3, 4].map((i) => Math.max(0, Math.min(1, Math.round((v - i) * 100) / 100))),
  };
}

/** Repeat-purchase rate as a whole percent, or null outside 0–1. */
export function repeatRatePct(rating) {
  const r = Number(rating?.repeat_purchase_rate);
  if (rating?.repeat_purchase_rate == null || rating?.repeat_purchase_rate === '' || !Number.isFinite(r) || r < 0 || r > 1) return null;
  return Math.round(r * 100);
}
